import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
